import React, { Component } from 'react';
import { Upload, Button } from 'antd';
import { prop } from 'ramda';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class FileComponent extends Component {
    onChange = (file) => {
        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            file
        );

        return false;
    }

    render() {
        const { field: { name, value }, placeholder } = this.props;
        const fileName = prop('name', value);

        return (
            <div className="file-input controls">
                <Upload
                    name={name}
                    beforeUpload={this.onChange}
                    showUploadList={false}
                >
                    <Button>Загрузить документ</Button>
                    <span className="upload-text">
                        {fileName || placeholder}
                    </span>
                </Upload>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/File.js